import { getWidgetMyServiceRequests } from '../../../../api'
import { useInfiniteItemsListLoader, useUserData } from '../../../../hooks'
import { isStaffUser } from '../../../../utils/user'
import { getMyUnreadEmails } from '../../../Email'
import { getMyTasks } from '../../../Task'

import {
  INIT_EMAIL_WIDGET_API_PARAMS,
  INIT_WIDGET_API_PARAMS,
} from './usePostsWidgetsData.constants'
import {
  getEmailsItems,
  getRequestsDataItems,
  getTasksDataItems,
} from './usePostsWidgetsData.utils'

export function usePostsWidgetsData({ isInitiated }) {
  const user = useUserData()

  const isStaffUserAcc = isStaffUser(user)

  const requestsLoader = useInfiniteItemsListLoader({
    apiParams: INIT_WIDGET_API_PARAMS,
    getData: getWidgetMyServiceRequests,
    getDataItems: getRequestsDataItems,
    loadPermission: isStaffUserAcc,
    preloading: !isInitiated,
    withPagination: true,
  })

  const tasksLoader = useInfiniteItemsListLoader({
    apiParams: INIT_WIDGET_API_PARAMS,
    getData: getMyTasks,
    getDataItems: getTasksDataItems,
    loadPermission: isStaffUserAcc,
    preloading: !isInitiated,
    withPagination: true,
  })

  const emailLoader = useInfiniteItemsListLoader({
    apiParams: INIT_EMAIL_WIDGET_API_PARAMS,
    getData: getMyUnreadEmails,
    getDataItems: getEmailsItems,
    loadPermission: isStaffUserAcc,
    preloading: !isInitiated,
    withPagination: true,
  })

  return {
    widgets: {
      emailLoader,
      requestsLoader,
      tasksLoader,
    },
  }
}
